import { KEYS } from '@/utils/constants';
import {
  SEARCH,
  DIRECTORY,
  KEYBOARD_SHORTCUTS,
  SEARCH_MESSAGES,
  SWITCH_TEAM,
} from './eventIds';

const {
  KEY_1,
  KEY_2,
  KEY_3,
  KEY_4,
  KEY_5,
  KEY_6,
  KEY_7,
  KEY_8,
  KEY_9,

  NUM_1,
  NUM_2,
  NUM_3,
  NUM_4,
  NUM_5,
  NUM_6,
  NUM_7,
  NUM_8,
  NUM_9,
} = KEYS;

export default [
  {
    id: SWITCH_TEAM,
    description: 'Switch teams',
    'win-electron': {
      modifiers: ['ctrlKey'],
      keyCodeForEventString: KEY_1,
      allowedKeyCodes: [
        KEY_1,
        KEY_2,
        KEY_3,
        KEY_4,
        KEY_5,
        KEY_6,
        KEY_7,
        KEY_8,
        KEY_9,
        NUM_1,
        NUM_2,
        NUM_3,
        NUM_4,
        NUM_5,
        NUM_6,
        NUM_7,
        NUM_8,
        NUM_9,
      ],
    },
    'mac-electron': {
      modifiers: ['metaKey'],
      keyCodeForEventString: KEY_1,
      allowedKeyCodes: [
        KEY_1,
        KEY_2,
        KEY_3,
        KEY_4,
        KEY_5,
        KEY_6,
        KEY_7,
        KEY_8,
        KEY_9,
        NUM_1,
        NUM_2,
        NUM_3,
        NUM_4,
        NUM_5,
        NUM_6,
        NUM_7,
        NUM_8,
        NUM_9,
      ],
    },
    'linux-electron': {
      modifiers: ['ctrlKey'],
      keyCodeForEventString: KEY_1,
      allowedKeyCodes: [
        KEY_1,
        KEY_2,
        KEY_3,
        KEY_4,
        KEY_5,
        KEY_6,
        KEY_7,
        KEY_8,
        KEY_9,
        NUM_1,
        NUM_2,
        NUM_3,
        NUM_4,
        NUM_5,
        NUM_6,
        NUM_7,
        NUM_8,
        NUM_9,
      ],
    },
  },
  {
    id: SEARCH,
    description: 'Start a search',
    'win-browser': {
      modifiers: ['ctrlKey'],
      keyCodeForEventString: KEYS.CHAR_K,
      allowedKeyCodes: [KEYS.CHAR_K, KEYS.CHAR_N],
    },
    'win-electron': {
      modifiers: ['ctrlKey'],
      keyCodeForEventString: KEYS.CHAR_N,
      allowedKeyCodes: [KEYS.CHAR_K, KEYS.CHAR_N],
    },
    'mac-browser': {
      modifiers: ['metaKey'],
      keyCodeForEventString: KEYS.CHAR_K,
      allowedKeyCodes: [KEYS.CHAR_K, KEYS.CHAR_N],
    },
    'mac-electron': {
      modifiers: ['metaKey'],
      keyCodeForEventString: KEYS.CHAR_N,
      allowedKeyCodes: [KEYS.CHAR_K, KEYS.CHAR_N],
    },
    'linux-electron': {
      modifiers: ['ctrlKey'],
      keyCodeForEventString: KEYS.CHAR_N,
      allowedKeyCodes: [KEYS.CHAR_K, KEYS.CHAR_N],
    },
    'linux-browser': {
      modifiers: ['ctrlKey'],
      keyCodeForEventString: KEYS.CHAR_K,
      allowedKeyCodes: [KEYS.CHAR_K, KEYS.CHAR_N],
    },
  },
  {
    id: DIRECTORY,
    description: 'Team Directory',
    'win-browser': {
      modifiers: ['ctrlKey'],
      keyCodeForEventString: KEYS.CHAR_D,
      allowedKeyCodes: [KEYS.CHAR_D],
    },
    'win-electron': {
      modifiers: ['ctrlKey'],
      keyCodeForEventString: KEYS.CHAR_D,
      allowedKeyCodes: [KEYS.CHAR_D],
    },
    'mac-browser': {
      modifiers: ['metaKey'],
      keyCodeForEventString: KEYS.CHAR_D,
      allowedKeyCodes: [KEYS.CHAR_D],
    },
    'mac-electron': {
      modifiers: ['metaKey'],
      keyCodeForEventString: KEYS.CHAR_D,
      allowedKeyCodes: [KEYS.CHAR_D],
    },
    'linux-electron': {
      modifiers: ['ctrlKey'],
      keyCodeForEventString: KEYS.CHAR_D,
      allowedKeyCodes: [KEYS.CHAR_D],
    },
    'linux-browser': {
      modifiers: ['ctrlKey'],
      keyCodeForEventString: KEYS.CHAR_D,
      allowedKeyCodes: [KEYS.CHAR_D],
    },
  },
  {
    id: KEYBOARD_SHORTCUTS,
    description: 'Keyboard Shortcuts Modal',
    'win-browser': {
      modifiers: ['ctrlKey'],
      keyCodeForEventString: KEYS.FORWARD_SLASH,
      allowedKeyCodes: [KEYS.FORWARD_SLASH],
    },
    'win-electron': {
      modifiers: ['ctrlKey'],
      keyCodeForEventString: KEYS.FORWARD_SLASH,
      allowedKeyCodes: [KEYS.FORWARD_SLASH],
    },
    'mac-browser': {
      modifiers: ['metaKey'],
      keyCodeForEventString: KEYS.FORWARD_SLASH,
      allowedKeyCodes: [KEYS.FORWARD_SLASH],
    },
    'mac-electron': {
      modifiers: ['metaKey'],
      keyCodeForEventString: KEYS.FORWARD_SLASH,
      allowedKeyCodes: [KEYS.FORWARD_SLASH],
    },
    'linux-electron': {
      modifiers: ['ctrlKey'],
      keyCodeForEventString: KEYS.FORWARD_SLASH,
      allowedKeyCodes: [KEYS.FORWARD_SLASH],
    },
    'linux-browser': {
      modifiers: ['ctrlKey'],
      keyCodeForEventString: KEYS.FORWARD_SLASH,
      allowedKeyCodes: [KEYS.FORWARD_SLASH],
    },
  },
  {
    id: SEARCH_MESSAGES,
    description: 'Search messages',
    'win-browser': {
      modifiers: ['ctrlKey'],
      keyCodeForEventString: KEYS.CHAR_F,
      allowedKeyCodes: [KEYS.CHAR_F],
    },
    'win-electron': {
      modifiers: ['ctrlKey'],
      keyCodeForEventString: KEYS.CHAR_F,
      allowedKeyCodes: [KEYS.CHAR_F],
    },
    'mac-browser': {
      modifiers: ['metaKey'],
      keyCodeForEventString: KEYS.CHAR_F,
      allowedKeyCodes: [KEYS.CHAR_F],
    },
    'mac-electron': {
      modifiers: ['metaKey'],
      keyCodeForEventString: KEYS.CHAR_F,
      allowedKeyCodes: [KEYS.CHAR_F],
    },
    'linux-electron': {
      modifiers: ['ctrlKey'],
      keyCodeForEventString: KEYS.CHAR_F,
      allowedKeyCodes: [KEYS.CHAR_F],
    },
    'linux-browser': {
      modifiers: ['ctrlKey'],
      keyCodeForEventString: KEYS.CHAR_F,
      allowedKeyCodes: [KEYS.CHAR_F],
    },
  },
];



// WEBPACK FOOTER //
// ./src/utils/KeyboardShortcuts/eventsDefinition.js